module.exports = __webpack_public_path__ + "assets/img/tx13g_1.d8cc11ef.jpg";